import React from 'react';

import { cn } from '@easydatasolution/ui-react/lib/utils';
import { StaticImage } from 'gatsby-plugin-image';

import { Heading } from '../Heading/Heading';
import { Image, ImageData } from '../Image/Image';

interface HeroImageData {
	image: ImageData;
	alt?: string | null;
	title?: string | null;
}

interface ImageRightHeroProps {
	heroImage: HeroImageData;
	title: string;
	description?: string | null;
	renderButtons: React.ReactNode[];
	className?: string;
}

export const ImageRightHero = ({
	heroImage,
	title,
	description,
	renderButtons,
	className,
}: ImageRightHeroProps) => {
	return (
		<div className={cn('relative', className)}>
			<div
				className={cn(
					'container grid grid-cols-1 gap-16 lg:grid-cols-2 2xl:grid-cols-5 2xl:gap-24',
				)}
			>
				<div className="max-w-[90vw] 2xl:col-span-3">
					<Heading as="h1" className="text-secondary-700">
						{title}
					</Heading>
					{description && <p className="mx-auto mt-3 text-lg text-secondary-700">{description}</p>}
					{renderButtons && (
						<div className="mt-8 flex flex-col gap-3 md:flex-row">{renderButtons}</div>
					)}
				</div>
				<div className="relative max-h-[400px] w-full xl:mt-8 xl:px-8 2xl:col-span-2">
					<Image
						image={heroImage.image}
						alt={heroImage.alt}
						title={heroImage.title ?? undefined}
						draggable={false}
					/>
				</div>
			</div>
			{/* absolute positioning does not work on the image itself, see https://github.com/gatsbyjs/gatsby/issues/5727#issuecomment-1081479991 */}
			<div className="absolute inset-0 -z-20 opacity-35">
				<StaticImage
					src="../../../static/images/hero_background.png"
					alt=""
					className="h-full w-full"
				/>
			</div>
		</div>
	);
};
